<template>
  <page>
    <div class="page-title">会员配置</div>

    <!-- 标签页内容 -->
    <div class="page-content" style="padding: 0">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="会员等级" name="memberLevel">
          <keep-alive>
            <MemberLevel v-if="activeTab === 'memberLevel'" @update="handleUpdate"></MemberLevel>
          </keep-alive>
        </el-tab-pane>
        <el-tab-pane label="单日提款限制名单" name="dailyWithdrawLimit">
          <keep-alive>
            <DailyWithdrawLimit v-if="activeTab === 'dailyWithdrawLimit'" @update="handleUpdate"></DailyWithdrawLimit>
          </keep-alive>
        </el-tab-pane>
      </el-tabs>
    </div>
  </page>
</template>

<script>
import DailyWithdrawLimit from './components/ConfigDailyWithdrawLimitTab.vue'
import MemberLevel from './components/ConfigMemberLevelTab.vue'

export default {
  name: 'AdminMemberConfig',
  components: {
    MemberLevel,
    DailyWithdrawLimit,
  },
  data() {
    return {
      activeTab: 'memberLevel',
    }
  },
  methods: {
    // 处理子组件更新事件
    handleUpdate() {
      this.$message.info('数据已更新')
    },
  },
}
</script>

<style scoped>
.page-content {
  padding: 0;
}
.page-content :deep(.el-tabs__item) {
  padding: 0 20px !important;
}
</style>
